import React, { useEffect, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Switch } from "../ui/switch";

export default function DemarchesPvSettings() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/demarches/settings").then((r) => setS(r.data)); }, []);
  const toggle = async (v) => {
    try { setS((await api.put("/demarches/settings", { tva_auto_send: v })).data); toast.success(v ? "Envoi automatique du mail TVA activé" : "Mail TVA : brouillon à valider"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  const importDrafts = async () => {
    setBusy(true);
    try { const r = await api.post("/message-templates/import-gmail-drafts"); toast.success(`${r.data.found} brouillon(s) trouvé(s), ${r.data.imported} nouveau(x) modèle(s)`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Import impossible"); } finally { setBusy(false); }
  };
  if (!s) return <Loader2 className="w-5 h-5 animate-spin" />;
  return (
    <div className="space-y-4 max-w-3xl" data-testid="demarches-pv-settings">
      <section className="card-flat p-5 space-y-2">
        <div className="flex items-center justify-between gap-4">
          <div><h3 className="font-heading text-base font-medium">Envoi automatique du mail TVA</h3>
            <p className="text-xs text-norea-textMuted mt-1">Quand un dossier PV passe au statut « Payé », la demande de récupération de TVA est préparée pour VD2E.
              Désactivé : brouillon dans « À approuver » (un clic pour envoyer). Activé : le mail part tout seul.</p>
            <p className="text-[11px] text-amber-700 mt-1">Destinataire et modèle provisoires — à n'activer qu'une fois validés par Norea.</p></div>
          <Switch checked={s.tva_auto_send} onCheckedChange={toggle} data-testid="tva-auto-send-switch" />
        </div>
      </section>
      <section className="card-flat p-5 space-y-2">
        <h3 className="font-heading text-base font-medium">Mails types — brouillons Gmail</h3>
        <p className="text-xs text-norea-textMuted">Importe les brouillons de administration.photovoltaique@norea.pro comme modèles (Modèles de messages), base des réponses de l'IA.
          En attendant l'accès à cette boîte, les modèles provisoires « Demande mairie », « Raccordement » et « TVA » sont utilisés.</p>
        <button onClick={importDrafts} disabled={busy} className="btn-secondary text-xs inline-flex items-center gap-1.5" data-testid="import-gmail-drafts-btn">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />}Importer les brouillons Gmail</button>
      </section>
    </div>
  );
}
